import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import type { Product } from '../api/product/types';
import { CheckoutButton } from './CheckoutButton';
import { getGALabelsWrapped } from './gtm/gtmLabels';
import { gtmPromotionView } from './gtm/gtmPromotions';
import { extractUrlParameters } from './urlUtils';
import './BuyButton.css';

interface Props {
    disabled: boolean;
    product?: Product;
}

export const BuyButtonButton = ({ disabled, product }: Props) => {
    const intl = useIntl();
    useEffect(gtmPromotionView, []);
    const { noButtonText, textOnly, notResponsive } = extractUrlParameters(window.location.href);

    const isResponsive = !notResponsive;
    const isTextOnly = !!textOnly;

    const tooltip = disabled ? intl.formatMessage({ id: 'marketplace.buybutton.notBookable' }) : undefined;

    const btnTypeClass = isTextOnly ? '' : 'btn btn-primary';
    const baseClasses = btnTypeClass + (disabled ? ' disabled' : '');
    const gaLabels = disabled ? undefined : getGALabelsWrapped();

    return (
        <div className={'buyButtonLink'} title={tooltip} {...gaLabels?.view}>
            {isResponsive && (
                <CheckoutButton
                    product={product}
                    className={`${baseClasses} btn-icon-only buyButtonCompact`}
                    disabled={disabled}
                    noText={true}
                    textOnly={isTextOnly}
                />
            )}
            <CheckoutButton
                product={product}
                className={`${baseClasses}${isResponsive && !isTextOnly ? ' buyButtonExpanded' : ''}${
                    noButtonText ? ' btn-icon-only' : ''
                }`}
                disabled={disabled}
                noText={!!noButtonText}
                textOnly={isTextOnly}
            />
        </div>
    );
};
